import {Component, OnInit} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import { Title } from '@angular/platform-browser';
import { AppConfigService } from '../../../../Services/app-config.service';
import { Router } from '@angular/router';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../../Services/ngbpagination-config.service';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-tax-list',
  templateUrl: './tax-list.component.html',
  styleUrls: ['./tax-list.component.css'],
  standalone: false
})
export class TaxListComponent extends ListPageBase implements OnInit {
  constructor(
    private tableDataService: DataService,
    private titleService: Title,
    private dateFilter: DateFilterService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  isLoaded = false;
  vm: any = { list: [] };




  ngOnInit() {
    this.restorePagerState();
    this.titleService.setTitle($localize`:Tax List @@taxList:Tax List`);

    this.vm.list = [];
    this.getData();
  }




  onNavigate(aID: string) {
    this.router.navigate(['admin//tax-form'], { queryParams: { taxId: aID } });
  }

  getData() {
    let paramString =
      '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString +=
      '&fromDate=' +
      (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString +=
      '&toDate=' +
      (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService
      .getApiListData('tax', paramString)
      .subscribe((result: ResponseModel) => {
        this.isLoaded = true;
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.vm.taxCount = result.totalRecords;
      });
  }
  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString =
      '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString +=
      '&fromDate=' +
      (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString +=
      '&toDate=' +
      (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService
      .getApiListData('tax', paramString)
      .subscribe((result: ResponseModel) => {
        this.isLoaded = true;
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.vm.taxCount = result.totalRecords;
      });
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }

}
